/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mark_InitialInputs */

const en_us2_coach_mark_initial = /** @type {(inputs: Coach_Mark_InitialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T`)
};

const pt_br2_coach_mark_initial = /** @type {(inputs: Coach_Mark_InitialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`P`)
};

const es_419_coach_mark_initial = /** @type {(inputs: Coach_Mark_InitialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E`)
};

const pt_pt2_coach_mark_initial = /** @type {(inputs: Coach_Mark_InitialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T`)
};

const fr_fr2_coach_mark_initial = /** @type {(inputs: Coach_Mark_InitialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C`)
};

const de_de2_coach_mark_initial = /** @type {(inputs: Coach_Mark_InitialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C`)
};

const it_it2_coach_mark_initial = /** @type {(inputs: Coach_Mark_InitialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C`)
};

/**
* | output |
* | --- |
* | "T" |
*
* @param {Coach_Mark_InitialInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mark_initial = /** @type {((inputs?: Coach_Mark_InitialInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mark_InitialInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mark_initial(inputs)
	if (locale === "es-419") return es_419_coach_mark_initial(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mark_initial(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mark_initial(inputs)
	if (locale === "de-DE") return de_de2_coach_mark_initial(inputs)
	if (locale === "it-IT") return it_it2_coach_mark_initial(inputs)
	return en_us2_coach_mark_initial(inputs)
});
export { coach_mark_initial as "coach.mark_initial" }